import React, { Component } from 'react'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'

import './css/index.css'
import {Button} from '@material-ui/core'
import Banner1 from '../../assets/image/ram-charam.png'
import join from '../../assets/image/join.jpg'

import Event from '../../components/grid/event'
import Insight from '../../components/grid/insight'
import Banner from '../../components/tribe/tribe_banner'
import Dot from '../../assets/image/Dot.svg'
import Chevron from '../../assets/image/chevron-right.svg'
import ServicesCarousel from './services_carousel'

import Chrpe from '../../assets/image/event/chrpe/chrpe-cover.jpg'
import Corpu from '../../assets/image/event/corpu/corpu_cover.jpg'
import Cptm from '../../assets/image/event/cptm/cptm_cover.jpg'
import Hr from '../../assets/image/event/hr_4.0/hr_cover.jpg'
import Hrbp from '../../assets/image/event/hrbp/hrbp_cover.jpg'
import Ram from '../../assets/image/event/ram/ram_cover.jpg'
import Rise from '../../assets/image/event/rise/rise_cover.jpg'

import newcorpu from '../../assets/image/cover-website-corpu.jpg'
import csep from '../../assets/image/cover-website-csep.jpg'
import idulfitri from '../../assets/image/idull-fitri-web.jpg'
import chrpe_inclass from '../../assets/image/event/chrpe_inclass.jpg'
import csep_inclass from '../../assets/image/event/csep_inclass.jpg'
import paul from '../../assets/image/event/paul.jpg'
import {getBanner} from '../../redux/action/home'
import {connect} from 'react-redux'
import {Helmet} from "react-helmet";
import ReactGA from 'react-ga';
import {TRACKING_ID} from '../../service/base_url'
class index extends Component {
    // componentDidMount(){
    //     ReactGA.initialize(TRACKING_ID);
    //     ReactGA.pageview(window.location.pathname);
    // }
    render() {
        const image=[
            // {image:paul},
            // {image:csep_inclass},
            {image:chrpe_inclass},
            // {image:csep},
            // {image:newcorpu},
            // {image:Banner1},
            {image:Ram},
            // {image:Chrpe},
            {image:Cptm},
            // {image:Rise},
        ]
        return (
            <>
             <Helmet>
            
            </Helmet>
            <Navbar/>
            <br/><br/><br/><br/><br/>
            <div className='homepage'>
                <Banner image={image} title="We enhance your execution capability" subtitle="We help you transform your organization’s execution capability through Strategy, Process, Structure, People, and Culture"/>
                
                <br/><br/>
                <ServicesCarousel/>
                <br/><br/>
                <section  className='event'>
                    <Event  jumlah={3}/>
                </section>
                <section className='insight'>
                    <Insight  jumlah={4}/>
                </section>
                <br/><br/><br/><br/>
                <section className="careers">
                    <div className="banner-join">
                        <div>
                        <h1>Join ONE GML</h1>
                        <br/>
                        <p>We seek a broad range of skills—from digital to interpersonal to analytical. Join us to make a lasting impact on our nation, industries, and society.</p>
                        <br/>
                        <Button style={{textTransform:'none',fontWeight:'bold'}} color="primary"
                            endIcon={<img src={Chevron} style={{width:13}}/>}
                            onClick={()=>window.location.assign('/careers')}
                        >Careers</Button>
                        </div>
                    </div>
                    <div className="image-join">
                        <div className='overlay-join'>
                        <img src={join} style={{width:'100%',height:320}}/>
                        </div>
                    </div>
                </section>
                <br/><br/><br/><br/>
                <section className="contact-us">
                    <div style={{width:450,marginLeft:'8%'}}>
                        <h1>How we can help your organization?</h1>
                    </div>
                    <div>
                        <Button style={{textTransform:'none'}} variant="contained" size="large" className="contact-button" onClick={()=>window.location.assign('/contact')}>Contact Us</Button>
                    </div>
                </section>
                <Footer/>
            </div>
            </>
        )
    }
}
// const mapStateToProps=(state)=>({
//     general:state.general,
//     home:state.home
// })
// const mapDispatchToProps={
//     getBanner
// }
// export default connect(mapStateToProps,mapDispatchToProps)(index)
export default index